import { useTranslation } from '../../i18n/LanguageContext'
import LangSwitcher from '../LangSwitcher/LangSwitcher'
import './Header.css'

const Header = ({ user, onAdminClick }) => {
  const { t } = useTranslation()
  return (
    <header className="header">
      {/* Admin Button - Only visible for admins */}
      {user?.isAdmin && (
        <button className="header__admin-btn" onClick={onAdminClick}>
          <svg viewBox="0 0 24 24" width="18" height="18">
            <path d="M12 2L9 7l-6 1 4 4-1 6 6-3 6 3-1-6 4-4-6-1-3-5z" fill="currentColor"/>
          </svg>
          <span>{t('hero.admin')}</span>
        </button>
      )}
      <LangSwitcher />
    </header>
  )
}

export default Header
